export const defaultFormValues = {
  description: undefined,
  content: {
    handler: {
      handler_id: undefined,
      policies: {
        detect_policy: {
          detect_face: 1,
          face_quality: {
            estimate: false,
            filter: 1,
          },
        },
        storage_policy: {
          face_policy: {
            store_face: 1,
            link_to_lists_policy: [],
          },
          attribute_policy: {
            store_attribute: 1,
          },
          notification_policy: {
            send_notification: 0,
          },
        },
        extract_policy: {
          extract_basic_attributes: 1,
        },
      },
    },
    source: {
      source_type: { value: 'file' },
      file: {
        reference: undefined,
      },
      zip: {
        reference: undefined,
      },
    },
  },
  notification_policy: {
    task_callbacks: [],
  },
};

export interface TPackageImportFormValues {
  description: string | undefined;
  content: {
    handler: {
      handler_id: string | undefined;
      policies: {
        detect_policy: {
          detect_face: number;
          face_quality: {
            estimate: boolean;
            filter: number;
          };
        };
        storage_policy: {
          face_policy: {
            store_face: number;
            link_to_lists_policy: unknown[];
          };
          attribute_policy: {
            store_attribute: number;
          };
          notification_policy: {
            send_notification: number;
          };
        };
        extract_policy: {
          extract_basic_attributes: number;
        };
      };
    };
    source: {
      source_type: { value: string };
      file?: {
        reference: unknown;
      };
      zip?: {
        reference: unknown;
      };
    };
  };
  notification_policy: {
    task_callbacks: unknown[];
  };
}
